import * as React from 'react';

import { graphql } from 'gatsby';

import PageWrapper from '../../components/PageWrapper';
import SEO from '../../components/misc/SEO';
import { getPageMetadata } from '../../utilities';
import content from './_content';
import ContactSectionForm from '../../components/hubspot-forms/ContactForm';
import ContactSectionTwoCards from '../../components/hubspot-forms/ContactSectionTwoCards';
import HeroSimpleTextLeft from '../../components/heros/HeroSimpleTextLeft';
import GetQuoteForm from '../../components/hubspot-forms/GetQuoteForm';

export default function GetQuotePage() {
  const { hero, form, offices } = content;
  return (
    <PageWrapper>
      <section className="py-24 lg:py-32">
        <HeroSimpleTextLeft
          title={hero.title}
          description={hero.description}
          links={hero.links}
          colorTheme="black"
        />
      </section>
      <ContactSectionForm
        form={form}
        hubspotForm={<GetQuoteForm />}
        colorTheme={form.colorTheme}
      />
      <section className="py-24 sm:py-32">
        <ContactSectionTwoCards
          title={offices.title}
          description={offices.description}
          contactCards={offices.contactCards}
        />
      </section>
    </PageWrapper>
  );
}

export const Head = props => {
  const { pageTitle, description, url, thumbnailSrc } = getPageMetadata(props);
  return (
    <SEO
      title={pageTitle}
      description={description}
      pathname={url}
      thumbnail={thumbnailSrc}
    />
  );
};

export const pageQuery = graphql`
  {
    metadata: allMdx(
      filter: {
        frontmatter: {
          pageMetadata: {
            contentType: { eq: "Web Pages" }
            url: { eq: "/get-quote" }
          }
        }
      }
    ) {
      edges {
        node {
          ...PageMetadata
        }
      }
    }

    images: allFile(filter: { absolutePath: { regex: "/assets/images/" } }) {
      edges {
        node {
          childCloudinaryAsset {
            gatsbyImageData
          }
        }
      }
    }

    resources: allMdx(
      filter: {
        frontmatter: {
          published: { eq: true }
          contentType: { eq: "Resources" }
        }
      }
    ) {
      edges {
        node {
          ...ResourceData
        }
      }
    }
  }
`;
